var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C5.8725 1 0.5 6.3725 0.5 13C0.5 19.6275 5.8725 25 12.5 25C19.1275 25 24.5 19.6275 24.5 13C24.5 6.3725 19.1275 1 12.5 1ZM9.5625 17.9738H7.1325V10.1537H9.5625V17.9738ZM8.3325 9.19375C7.565 9.19375 7.06875 8.65 7.06875 7.9775C7.06875 7.29125 7.58 6.76375 8.36375 6.76375C9.1475 6.76375 9.6275 7.29125 9.6425 7.9775C9.6425 8.65 9.1475 9.19375 8.3325 9.19375ZM18.4375 17.9738H16.0075V13.64C16.0075 12.6313 15.655 11.9462 14.7763 11.9462C14.105 11.9462 13.7063 12.41 13.53 12.8563C13.465 13.015 13.4488 13.24 13.4488 13.4638V17.9725H11.0175V12.6475C11.0175 11.6713 10.9862 10.855 10.9537 10.1525H13.065L13.1763 11.2388H13.225C13.545 10.7288 14.3288 9.97625 15.64 9.97625C17.2388 9.97625 18.4375 11.0475 18.4375 13.35V17.9738Z",
    fill: "#0075B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.64751cb0f10cf8e71e9666e80bf4684d.svg";
export { ForwardRef as ReactComponent };